export const generateUUID = () => {
  // Usamos la API nativa del navegador si está disponible
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback simple
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const mapDraftToInitParams = (savedDraft: any) => {
  const params: Record<string, string[]> = {};

  if (!savedDraft || !savedDraft.payload || !savedDraft.payload.questions) return params;

  savedDraft.payload.questions.forEach((q: any) => {
    const key = String(q.id);

    if (q.answers && Array.isArray(q.answers)) {
      q.answers.forEach((ans: any) => {
        let val = String(ans.id);

        // Si tiene valor de texto custom, usamos el separador
        if (ans.value) {
          val = `${ans.id}::${ans.value}`;
        }

        if (!params[key]) params[key] = [];
        params[key].push(val);
      });
    }
  });

  return params;
};